import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { EBM_CAPABILITIES } from '../capabilities';
import { EBM_FIELD_KEYS } from '../fields';
import { EBM_MODULES } from '../modules';
import { ebmMigrations } from './migrations';
import { buildEbmDisplayDescriptors, buildEbmResourceConfigs, pickEbmPresetFields, serializeEbmApiBody } from './projections';
import { type EbmApiPayload, type EbmSpec, EbmSpecSchema } from './schema';
import { ebmFromForm, ebmGetInitialFormValues, ebmToForm } from './spec';
import { assertEbmSubmitReady } from './validateSubmit';

export const ebmHeadless = createDeployPluginHeadless<EbmSpec, EbmApiPayload, (typeof EBM_FIELD_KEYS)[number]>({
  code: 'ElasticBareMetal',
  fieldKeys: EBM_FIELD_KEYS,
  modules: EBM_MODULES,
  capabilities: EBM_CAPABILITIES,
  schema: EbmSpecSchema,
  fromForm: ebmFromForm,
  toForm: ebmToForm,
  getInitialFormValues: ebmGetInitialFormValues,
  assertSubmitReady: assertEbmSubmitReady,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeEbmApiBody,
      skuPreset: pickEbmPresetFields,
      buildDisplayDescriptors: buildEbmDisplayDescriptors,
      skuResources: buildEbmResourceConfigs,
    },
  },
  migrations: ebmMigrations,
});

export const ebmPipeline = ebmHeadless.pipeline;

export { buildEbmDeliveryMetadata, buildEbmOrderDeliveryMetadata } from './deliveryMetadata';
export type { BuildEbmDeliveryMetadataInput, BuildEbmOrderDeliveryMetadataContext, EbmDeliveryMetadata } from './deliveryMetadata';
